// Full i18n translations for Leadeverest
// Languages: hu (default), en, sk, de

export const LANGS = [
  { code: 'hu', label: 'Magyar', flag: '🇭🇺' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'sk', label: 'Slovenčina', flag: '🇸🇰' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
];

export const translations = {
  hu: {
    nav: {
      home: 'Kezdőlap',
      services: 'Szolgáltatások',
      about: 'Rólunk',
      references: 'Referenciák',
      contact: 'Kapcsolat',
      consultation: 'Ingyenes konzultáció',
      consultation_short: 'Konzultáció',
    },
    common: {
      free_consultation: 'Ingyenes konzultáció',
      our_services: 'Szolgáltatásaink',
      learn_more: 'Bővebben',
      contact: 'Kapcsolat',
      live: 'ÉLŐ',
      verified: 'Verifikált',
    },
    hero: {
      tag: 'International Sales Agency',
      title_a: 'Minden perc, amikor',
      title_b: 'nem minket választ,',
      title_c: 'a versenytársainak kedvez.',
      description:
        'Kiszámítható, mérhető sales pipeline a célpiac kiválasztásától a szerződéskötésig — saját cégadatbázisunkra, célzott e-mail kampányokra és többnyelvű telefonos megkeresésre építve.',
      trust_1: 'Saját cégadatbázis',
      trust_2: 'Valós idejű riportok',
      trust_3: '5 nyelven',
      markets_title: 'Aktív piacaink',
      markets_stat: '79 000+',
      markets_stat_label: 'strukturált cég az adatbázisunkban',
    },
    markets: {
      HU: 'Magyarország',
      SK: 'Szlovákia',
      CZ: 'Csehország',
      AT: 'Ausztria',
    },
    services_grid: {
      tag: 'Amit kínálunk',
      title_a: 'Kilenc terület, egy egységes',
      title_b: 'sales gépezet.',
      subtitle: 'A cégadatbázistól a szerződéskötésig — végig egy csapattal.',
      cards: [
        { title: 'Cégadatbázis országonként', tag: 'HU · SK · CZ · AT' },
        { title: 'Időpontszervezés', tag: null },
        { title: 'Hideghívás', tag: null },
        { title: 'Telemarketing', tag: null },
        { title: 'Munkatárs biztosítása', tag: null },
        { title: 'Terjeszkedés', tag: 'HU · SK · CZ · AT' },
        { title: 'Branding', tag: null },
        { title: 'Marketing', tag: null },
        { title: 'Social Media', tag: null },
      ],
    },
    about_intro: {
      tag: 'Leadeverest',
      title_a: 'Az eredmény',
      title_b: 'számít.',
      p1:
        'A Leadeverest egy eredményorientált ügyfélszerzési csapat: kiszámítható, mérhető pipeline-t építünk a célpiac kiválasztásától a szerződéskötésig.',
      p2:
        'Erős értékünk: a saját, országonként strukturált cégadatbázisunk (HU / SK / CZ / AT), amire célzott e-mail kampányokat és telefonos megkeresést építünk a minősített meetingekért és dedikált SALES munkatársat biztosítunk a szerződéskötésekhez.',
      p3: 'Nyelvek: magyar, szlovák, cseh, angol, német.',
      p4:
        'Hiszünk az emberi kapcsolatok erejében: a bizalom, a korrekt kommunikáció és a következetes utánkövetés szerintünk mindig erősebb, mint bármilyen „trükk".',
    },
    process: {
      tag: 'Szolgáltatásaink',
      title_a: 'Egy világos folyamat,',
      title_b: 'hét bevétel-hozó modul.',
      cta_cell_title: 'Nyissa meg a teljes szolgáltatásárunkat',
      steps: [
        { title: 'Cégadatbázis HU / SK / CZ / AT', desc: 'Céglista szűrőkkel és elérhetőségekkel.' },
        { title: 'E-mail marketing', desc: 'Tömeges e-mail küldése + időpontfoglalási CTA + riport.' },
        { title: 'Telefonos megkeresések', desc: 'Hideghívások, telemarketing HU/SK/CZ/EN/DE nyelveken.' },
        {
          title: 'Munkatárs biztosítása',
          desc:
            'Rövid és hosszútávú értékesítési erőforrás igény szerint HU/SK/CZ/EN/DE nyelveken rendszerünk használatával + meglévő ügyfélgondozás.',
        },
        {
          title: 'Marketing + PPC',
          desc:
            'Branding, videók, kreatívok, arculat, promó anyagok, névjegykártya, social media kampánytervezés és futtatás.',
        },
        {
          title: 'Terjeszkedés támogatása (HU/SK/CZ/AT)',
          desc: 'Piackutatás, cégalapítás, bankszámla, egyéb ügyintézés.',
        },
        { title: 'Havi riport készítése', desc: 'Státuszok, KPI-k, következő lépések, rendszeres összefoglaló.' },
      ],
    },
    about_stats: {
      tag: 'Rólunk',
      title_a: 'Adatokkal dolgozunk,',
      title_b: 'eredményben mérünk,',
      title_c: 'emberi kapcsolatokban hiszünk.',
      story_label: 'A történetünk',
      story_1:
        '2023-ban, Pozsonyban alapítottuk meg a GLOBEFOX Nemzetközi Munkaerő-ügynökséget — innen indult a nemzetközi sales fókusz, amely ma a Leadeverest alapja.',
      story_2:
        'Ma már Magyarországon, Szlovákiában és Csehországban is toborzunk, és több mint 50 partnerrel dolgozunk együtt, köztük gyáróriásokkal és piacvezető cégekkel.',
      stats: [
        { value: '2023', label: 'Alapítva Pozsonyban' },
        { value: '50+', label: 'Aktív partner' },
        { value: '4', label: 'Piac · HU / SK / CZ / AT' },
        { value: '5', label: 'Nyelv · HU / SK / CZ / EN / DE' },
      ],
      why_label: 'Miértünk',
      why_title_a: 'Négy alapelv, egy vezérfonal:',
      why_title_b: 'eredmény.',
      principles: [
        {
          title: 'Adatvezérelt sales',
          desc:
            'Saját, országonként strukturált cégadatbázisunkból építünk mérhető pipeline-t — nem sejtésből dolgozunk.',
        },
        {
          title: 'Mérhető eredmények',
          desc: 'Heti státusz, KPI-k, riportok — mindig tudja, hol tart a folyamat és mi a következő lépés.',
        },
        {
          title: 'Emberi kapcsolatok',
          desc: 'A bizalom, a korrekt kommunikáció és a következetes utánkövetés erősebb, mint bármilyen trükk.',
        },
        {
          title: 'Többnyelvű működés',
          desc: 'Magyar, szlovák, cseh, angol és német nyelven képviseljük ügyfeleinket, határokon átívelően.',
        },
      ],
    },
    team: {
      title_a: 'Az arcok',
      title_b: 'a folyamatok mögött.',
      section_label: 'A csapat',
      members: [
        {
          role: 'Ügyvezető / CEO · International Lawyer',
          name: 'Somogyi Antónia',
          bio:
            '2023-ban, Pozsonyban alapítottuk meg a GLOBEFOX Nemzetközi Munkaerő-ügynökséget. Én nemzetközi jogászként csatlakoztam a munkához, és négy nyelven beszélek. Ez tette lehetővé, hogy a GLOBEFOX kezdettől nemzetközi irányba induljon, és ma már Magyarországon, Szlovákiában és Csehországban is toborozzunk. Mára már több mint 50 partnerrel dolgozunk együtt, köztük gyáróriásokkal és piacvezető cégekkel.',
        },
        {
          role: 'COO / Operatív vezető · Alapító',
          name: 'Korcz Antal',
          bio:
            'Stratégiáért és az értékesítési rendszerek felépítéséért felelek: célom, hogy minden ügyfelünk olyan sales-megoldást kapjon, amely valódi növekedést és stabil ügyfélszerzést biztosít. Napi szinten foglalkozom kampányok tervezésével, adatalapú optimalizálással és azokkal a folyamatokkal, amelyek biztosítják, hogy ügyfeleink több érdeklődőt, időpontot és új ügyfelet érjenek el.',
        },
      ],
    },
    situations: {
      tag: 'Melyik igaz Önre?',
      title_a: 'Mondja el',
      title_b: 'nekünk!',
      subtitle: 'Ha a lenti helyzetek közül akár csak egy is ismerős, valószínűleg dolgozhatunk együtt.',
      items: [
        'Jó a termékem/szolgáltatásom, de több ügyfelet szeretnék.',
        'Terjeszkedni szeretnék egy másik országban.',
        'Kell egy profi marketinges.',
        'Nem látok rá a fizetett kollégám munkájára: hány céget hívtunk fel?',
        'Új munkatársra lenne szükségem.',
        'Döntéshozókat szeretnék elérni, nem általános kontaktokat.',
        'Nincs időm napi szinten keresgélni és hívogatni.',
        'Megoldásokat akarok, nem mellébeszédet.',
        'Keveset foglalkozom a meglévő ügyfeleimmel.',
      ],
    },
    testimonials: {
      tag: 'Referenciák',
      title_a: 'Partnereink sikerei',
      title_b: 'a mi legfontosabb referenciánk.',
      subtitle: '50+ partner · 4 piac · 5 nyelv',
      items: [
        {
          company: 'WHC SLOVAKIA',
          role: 'CEO',
          quote:
            'Kiemelten értékeljük a csapat hozzáállását, pontosságát és azt, hogy valódi üzleti eredményekben gondolkodnak. A Leadeverest olyan partner, akire egy növekedésorientált vállalat bátran rábízhatja az értékesítési folyamatainak egy részét vagy egészét.',
        },
        {
          company: 'iNTRETECH',
          role: 'CEO',
          quote:
            'Antallal és Antóniával való együttműködés során egy olyan partnerre találtunk, amely valódi értéket teremt az értékesítési folyamatainkban. A megkeresések minősége, a riportálás átláthatósága és a csapat szakmai felkészültsége megerősítette bennünk, hogy az adatvezérelt sales ma már elengedhetetlen.',
        },
        {
          company: 'MOTIM ZRT.',
          role: 'CEO',
          quote:
            'A Leadeverest csapatával gyorsan világossá vált, hogy nem egyszerű szolgáltatót választottunk, hanem valódi stratégiai partnert. A rendszerük átlátható, a kommunikációjuk professzionális, és minden tevékenységük mérhető. A Leadeverest konkrét, számonkérhető eredményeket szállít – ezért dolgozunk velük.',
        },
      ],
    },
    banner_data: {
      eyebrow: 'Adatvezérelt sales',
      title_a: 'Nem sejtésből dolgozunk —',
      title_b: 'számokból építünk pipeline-t.',
      desc:
        'Saját, országonként strukturált cégadatbázisunk (HU / SK / CZ / AT) minden szűrő szempontból friss. A célpiac kijelölésétől a szegmentált outreach kampányig egy rendszerből, egy csapattal.',
      label: '79 000+ strukturált cég',
    },
    banner_measurable: {
      eyebrow: 'Mérhető eredmények',
      title_a: 'Heti státusz, KPI-k, riportok —',
      title_b: 'mindig tudja, hol tart a folyamat.',
      desc:
        'A kampány első hetétől követhető minden aktivitás: kiküldött e-mailek, hívások, foglalt időpontok, konverziók. Nincs feketedoboz, csak tiszta, adatalapú döntések.',
      label: 'KPI-vezérelt működés',
    },
    banner_human: {
      eyebrow: 'Emberi kapcsolatok',
      title_a: 'Emberi hívások,',
      title_b: 'valódi meetingek.',
      desc:
        'A bizalom, a korrekt kommunikáció és a következetes utánkövetés erősebb, mint bármilyen trükk. HU / SK / CZ / EN / DE nyelveken képviseljük az Ön cégét — a döntéshozók szintjén.',
      label: '5 nyelv · 4 piac',
    },
    expansion: {
      tag: 'Nemzetközi terjeszkedés',
      title_a: 'Új piacok —',
      title_b: 'kisebb kockázattal.',
      desc:
        'Piackutatás, belépési stratégia, célzott céglista, többnyelvű outreach és személyes képviselet — végig egy csapattal, egy kontaktponttal. Cégalapítás, bankszámla, ügyintézés opcionálisan.',
      markets_label: 'Elérhető piacok',
      markets_subtitle: 'ország\negy folyamatban',
      structured_companies: 'strukturált cég',
      capitals: { HU: 'Budapest', SK: 'Pozsony', CZ: 'Prága', AT: 'Bécs' },
      steps: [
        { title: 'Piackutatás', desc: 'Iparág, régió, versenykörnyezet' },
        { title: 'Belépési stratégia', desc: 'Kinek, mivel, hogyan' },
        { title: 'Cégalapítás', desc: 'Opcionális helyi entitás' },
        { title: 'Skálázás', desc: 'A működő szegmensekre' },
      ],
      cta_label: 'Készen áll a következő piacra?',
      cta_title_a: 'Mutassuk meg 15 percben, hogyan indíthatja el az outreach-et',
      cta_title_b: 'még ezen a héten.',
    },
    goal: {
      tag: 'Célunk',
      title_a: 'Eredményeket hozni —',
      title_b: 'a jobb ügyfélgondozástól',
      title_c: 'az új piacokig.',
      desc:
        'Eredményeket hozni, a jobb ügyfélgondozástól kezdve az értékesítés növelésén át egészen az új piacok megnyitásáig. Velünk megbízható partnert szerez, aki lépésről lépésre támogatja vállalkozása fejlődését.',
      brochure: 'Cégbemutató prezentáció',
      mission: 'MISSION',
      mission_title: 'Mérhető növekedés',
    },
    contact: {
      tag: 'Kapcsolat',
      title_a: 'Kérdése van?',
      title_b: '24 órán belül válaszolunk.',
      offices_label: 'Irodáink',
      form: {
        name: 'Név',
        name_ph: 'Teljes név',
        email: 'E-mail',
        email_ph: 'pelda@ceg.hu',
        phone: 'Telefonszám',
        phone_ph: '+36 70 000 0000',
        company: 'Cégnév',
        company_hint: 'Opcionális — magánszemélyként hagyja üresen',
        company_ph: 'Cégnév (ha van)',
        message: 'Üzenet',
        message_ph: 'Miben segíthetünk?',
        send: 'Üzenet küldése',
        sending: 'Küldés…',
        sent: 'Elküldve',
        privacy:
          'Az üzenet elküldésével Ön hozzájárul, hogy megadott adatait a Leadeverest visszajelzés céljából kezelje.',
        toast_ok_title: 'Üzenete elküldve',
        toast_ok_desc: '24 órán belül válaszolunk. Köszönjük!',
        toast_err_title: 'Nem sikerült elküldeni',
        toast_err_desc: 'Kérjük, próbálja újra vagy írjon közvetlenül: antal@leadeverest.eu',
      },
    },
    footer: {
      description: 'International Sales Agency. Adatvezérelt ügyfélszerzés HU / SK / CZ / AT piacokon.',
      nav_label: 'Navigáció',
      contact_label: 'Kapcsolat',
      offices_label: 'Irodáink',
      rights: '— International Sales Agency. Minden jog fenntartva.',
    },
    services_page: {
      hero_tag: 'Szolgáltatásaink',
      hero_title_a: 'Digitális és emberi értékesítés',
      hero_title_b: 'összehangolva,',
      hero_title_c: 'eredményre optimalizálva.',
      hero_desc: 'Hat modul, egy egységes folyamat — a piackutatástól a személyes képviseletig.',
      anchors: {
        cegadatbazis: 'Cégadatbázis',
        email: 'E-mail marketing',
        phone: 'Telefonos megkeresés',
        staff: 'Munkatárs biztosítása',
        marketing: 'Marketing',
        expansion: 'Terjeszkedés',
      },
      cegdb: {
        tag: 'Adatvezérelt értékesítés',
        title: 'Cégadatbázis',
        p1: 'A cégekről rövid információt, webhelyelérhetőségeket is tartalmaz.',
        p2:
          'Ha eddig Google-ben kereste a potenciális célpartnereket, ezzel jelentősen felgyorsítható a piackutatás és a megkeresés.',
        p3: 'Név szerinti elérhetőségeket tartalmazó adatbázisunkat folyamatosan frissítjük.',
        filters_label: 'A következő szűrők állnak rendelkezésünkre:',
        filters: ['Iparág', 'Cégméret (employee count)', 'Telephelyszám', 'Régió'],
        countries: [
          { flag: '🇭🇺', label: 'cég', value: '16 000', country: 'Magyarország' },
          { flag: '🇸🇰', label: 'cég', value: '13 000', country: 'Szlovákia' },
          { flag: '🇦🇹', label: 'cég', value: '47 000', country: 'Ausztria' },
          { flag: '🇨🇿', label: 'cég', value: '3 000', country: 'Csehország' },
        ],
      },
      email: {
        tag: 'Folyamat',
        title: 'E-mail marketing',
        desc: 'Kampányok tervezése, ütemezése és mérése — az Ön céges e-mail címéről kiküldve.',
        video_label: 'E-mail marketing',
        steps: [
          { title: 'Célcsoport kiválasztása a cégadatbázisból', desc: 'Szűrés iparág, régió, cégméret.' },
          {
            title: 'Tömeges e-mail sorozatok',
            desc: 'Hírlevél, bemutatkozó, ajánlati üzenetek, ütemezett utánkövetéssel, leiratkozási lehetőséggel.',
          },
          {
            title: 'Beépített időpontfoglalás (CTA)',
            desc:
              'A címzett 1 kattintással 15 perces egyeztetést foglal, a rendszer automatikusan rögzíti az eseményt és a naptárba teszi.',
          },
          {
            title: 'Valós idejű tracking és riport',
            desc:
              'Kézbesítés, megnyitás, kattintás, válasz, időpontfoglalás — kampányonként és címzettenként is visszamérhető.',
          },
          {
            title: 'Az Ön céges e-mail címéről',
            desc:
              'Az e-mail sorozatokat az Ön vállalati e-mail címéről küldjük ki, így Ön is közvetlenül nyomon tudja követni a kiküldéseket, a válaszokat és az egyeztetések alakulását.',
          },
        ],
      },
      phone: {
        tag: 'Szolgáltatás',
        title: 'Telefonos megkeresés',
        desc: 'Hideg- és felmelegített hívások öt nyelven — döntéshozói meetingekért.',
        video_label: 'Telefonos megkeresés',
        items: [
          { title: 'Hideg hívások', desc: 'Adatbázisból keressük a cégeket, felépített beszélgetési vázlattal.' },
          { title: 'Felmelegített hívások', desc: 'Azokat is hívjuk, akik az e-mail kampányban aktivitást mutattak.' },
          { title: 'Időpont szervezés', desc: 'Célunk elérni a döntéshozót, időpontot szervezni az értékesítőnek.' },
          { title: 'Telemarketing', desc: 'Betanulás és telefonos értékesítés + riport.' },
          {
            title: 'Többnyelvű megkeresés',
            desc: 'A hívásokat és az utánkövetést magyar, szlovák, cseh, angol és német nyelven is vállaljuk.',
          },
          {
            title: 'Átadás és dokumentálás',
            desc: 'Kivel mi volt, mi hangzott el, mi az igény, mi a következő lépés, egyeztetett időpont, vagy elutasítás.',
          },
        ],
      },
      staff: {
        tag: 'Szolgáltatás',
        title: 'Munkatárs biztosítása',
        desc: 'Dedikált értékesítési erőforrás — a mi workflow-nkkal, teljes eszközbiztosítással.',
        video_label: 'Munkatárs biztosítása',
        items: [
          {
            title: 'Sales, telefonos értékesítő, ügyintéző vagy koordinátor munkaerő biztosítása',
            desc:
              'Önéletrajzokból választható alkalmi vagy hosszútávú partner, aki a megbízó cég „arca" és az Ön cége nevében kommunikál HU / SK / CZ / EN / DE nyelveken.',
          },
          { title: 'Rendszer', desc: 'A munkatárs a mi workflow-nkat használja (státuszok, utánkövetés, meeting brief, riportok).' },
          {
            title: 'Teljes eszközbiztosítás igény esetén',
            desc: 'Céges autó, telefon és laptop biztosítása, hogy a munkavégzés azonnal, professzionális szinten indulhasson.',
          },
          { title: 'Onboarding és betanítás', desc: 'Felkészítés a termékre, célpiacra.' },
          {
            title: 'Szakmai felügyelet',
            desc: 'Vezetés és minőségellenőrzés, heti státusz/riport készítése + pipeline, hogy mindig lássuk, hol tartunk.',
          },
        ],
      },
      marketing: {
        tag: 'Szolgáltatás',
        title: 'Marketing',
        desc: 'Branding, kreatív gyártás, PPC kampányok és sales anyagok egy csapattól.',
        video_label: 'Marketing',
        items: [
          { title: 'Branding', desc: 'Arculat és logo tervezés.' },
          { title: 'Kreatív gyártás', desc: 'Professzionális képek, videók, grafikai anyagok, animációk, több nyelven is.' },
          { title: 'Sales anyagok', desc: 'Prezentációk, ajánlati anyagok, one-pager, névjegykártya, promóciós anyagok.' },
          { title: 'Online hirdetések (PPC)', desc: 'Kampánytervezés, beállítás, folyamatos optimalizálás (FB/IG/Google).' },
          { title: 'Közösségi média tartalom és kampányok', desc: 'Posztok, hirdetések.' },
          { title: 'Mérés és riportálás', desc: 'KPI-k követése, tanulságok, finomhangolás és skálázás.' },
        ],
      },
      expansion: {
        tag: 'Folyamat',
        title_a: 'Terjeszkedne?',
        title_b: 'Segítünk!',
        desc: 'Piackutatás, belépési stratégia és teljes lokális képviselet HU/SK/CZ/AT piacokon.',
        video_label: 'Terjeszkedés',
        steps: [
          { title: 'Piackutatás és célpiac-kijelölés', desc: 'Országonkénti fókusz (iparág, cégméret, régió, versenykörnyezet).' },
          { title: 'Belépési stratégia és ütemezés', desc: 'Kinek adunk el, milyen ajánlattal, mely csatornákon, milyen lépésekben.' },
          {
            title: 'Célzott céglista és döntéshozói elérhetőségek',
            desc: 'Az adott országban, saját adatbázisunkra építve (HU / SK / CZ / AT).',
          },
          { title: 'Piacnyitó outreach kampányok', desc: 'Szegmentált bemutatkozó e-mailek + több lépéses utánkövetés.' },
          {
            title: 'Többnyelvű telefonos megkeresés és időpontszervezés',
            desc: 'HU / SK / CZ / EN / DE nyelveken, minősített meetingekkel.',
          },
          { title: 'Személyes képviselet', desc: 'Alkalmi projektek és hosszútávú projektek egyaránt.' },
          {
            title: 'Riportálás és optimalizálás',
            desc: 'Eredmények mérése, finomhangolás, skálázás a legjobban működő szegmensekre.',
          },
          {
            title: 'Opcionális: Cégalapítás, fordítás, bankszámlanyitás, egyéb ügyintézés',
            desc: 'Gyakorlati segítség az induláshoz és működéshez.',
          },
        ],
      },
      final_cta: {
        tag: 'Készen áll a következő lépésre?',
        title_a: 'Egy 15 perces beszélgetés',
        title_b: 'a következő piacáról.',
        desc:
          'Mutassuk meg, hogyan építünk mérhető pipeline-t a saját cégadatbázisunkkal HU / SK / CZ / AT piacokon.',
      },
    },
    lang_switch: 'Nyelv',
  },

  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      references: 'References',
      contact: 'Contact',
      consultation: 'Free consultation',
      consultation_short: 'Consult',
    },
    common: {
      free_consultation: 'Free consultation',
      our_services: 'Our services',
      learn_more: 'Learn more',
      contact: 'Contact',
      live: 'LIVE',
      verified: 'Verified',
    },
    hero: {
      tag: 'International Sales Agency',
      title_a: 'Every minute',
      title_b: 'they don\'t choose us,',
      title_c: 'goes to your competitors.',
      description:
        'A predictable, measurable sales pipeline from target market selection to contract signing — built on our own company database, targeted email campaigns and multilingual phone outreach.',
      trust_1: 'Own company database',
      trust_2: 'Real-time reports',
      trust_3: '5 languages',
      markets_title: 'Active markets',
      markets_stat: '79,000+',
      markets_stat_label: 'structured companies in our database',
    },
    markets: {
      HU: 'Hungary',
      SK: 'Slovakia',
      CZ: 'Czech Republic',
      AT: 'Austria',
    },
    services_grid: {
      tag: 'What we offer',
      title_a: 'Nine areas, one unified',
      title_b: 'sales engine.',
      subtitle: 'From company database to signed contracts — with one team all the way.',
      cards: [
        { title: 'Company database per country', tag: 'HU · SK · CZ · AT' },
        { title: 'Appointment setting', tag: null },
        { title: 'Cold calling', tag: null },
        { title: 'Telemarketing', tag: null },
        { title: 'Staff placement', tag: null },
        { title: 'Market expansion', tag: 'HU · SK · CZ · AT' },
        { title: 'Branding', tag: null },
        { title: 'Marketing', tag: null },
        { title: 'Social Media', tag: null },
      ],
    },
    about_intro: {
      tag: 'Leadeverest',
      title_a: 'Results',
      title_b: 'matter.',
      p1:
        'Leadeverest is a results-driven customer acquisition team: we build a predictable, measurable pipeline from target market selection to signed contracts.',
      p2:
        'Our core value: our own, country-structured company database (HU / SK / CZ / AT), on which we build targeted email campaigns and phone outreach for qualified meetings, plus we provide a dedicated SALES specialist for closings.',
      p3: 'Languages: Hungarian, Slovak, Czech, English, German.',
      p4:
        'We believe in the power of human relationships: trust, honest communication and consistent follow-up are always stronger than any "trick".',
    },
    process: {
      tag: 'Our services',
      title_a: 'One clear process,',
      title_b: 'seven revenue-driving modules.',
      cta_cell_title: 'See our full service catalogue',
      steps: [
        { title: 'Company database HU / SK / CZ / AT', desc: 'Company list with filters and contact details.' },
        { title: 'Email marketing', desc: 'Bulk email sending + booking CTA + reporting.' },
        { title: 'Phone outreach', desc: 'Cold calls and telemarketing in HU/SK/CZ/EN/DE.' },
        {
          title: 'Staff placement',
          desc:
            'Short- and long-term sales resource on demand in HU/SK/CZ/EN/DE using our system + existing account management.',
        },
        {
          title: 'Marketing + PPC',
          desc: 'Branding, videos, creatives, visual identity, promo materials, business cards, social media planning and running.',
        },
        {
          title: 'Expansion support (HU/SK/CZ/AT)',
          desc: 'Market research, company setup, bank account, other administrative help.',
        },
        { title: 'Monthly reporting', desc: 'Statuses, KPIs, next steps, regular summary.' },
      ],
    },
    about_stats: {
      tag: 'About us',
      title_a: 'We work with data,',
      title_b: 'we measure by results,',
      title_c: 'we believe in human relationships.',
      story_label: 'Our story',
      story_1:
        'In 2023, we founded GLOBEFOX International Employment Agency in Bratislava — this is where the international sales focus began, which is now the foundation of Leadeverest.',
      story_2:
        'Today we also recruit in Hungary, Slovakia and the Czech Republic, working with more than 50 partners, including manufacturing giants and market leaders.',
      stats: [
        { value: '2023', label: 'Founded in Bratislava' },
        { value: '50+', label: 'Active partners' },
        { value: '4', label: 'Markets · HU / SK / CZ / AT' },
        { value: '5', label: 'Languages · HU / SK / CZ / EN / DE' },
      ],
      why_label: 'Why us',
      why_title_a: 'Four principles, one common thread:',
      why_title_b: 'results.',
      principles: [
        {
          title: 'Data-driven sales',
          desc: 'We build a measurable pipeline from our own country-structured database — no guesswork.',
        },
        {
          title: 'Measurable results',
          desc: 'Weekly status, KPIs, reports — you always know where the process stands and what\'s next.',
        },
        {
          title: 'Human relationships',
          desc: 'Trust, honest communication and consistent follow-up are stronger than any trick.',
        },
        {
          title: 'Multilingual operation',
          desc: 'We represent our clients across borders in Hungarian, Slovak, Czech, English and German.',
        },
      ],
    },
    team: {
      title_a: 'The faces',
      title_b: 'behind the processes.',
      section_label: 'The team',
      members: [
        {
          role: 'Managing Director / CEO · International Lawyer',
          name: 'Antónia Somogyi',
          bio:
            'In 2023, we founded the GLOBEFOX International Employment Agency in Bratislava. I joined as an international lawyer and speak four languages. This allowed GLOBEFOX to go international from day one, and today we recruit in Hungary, Slovakia and the Czech Republic. We now work with more than 50 partners, including manufacturing giants and market leaders.',
        },
        {
          role: 'COO / Operations Lead · Founder',
          name: 'Antal Korcz',
          bio:
            'I\'m responsible for strategy and building sales systems: my goal is that every client gets a sales solution that delivers real growth and stable customer acquisition. My day-to-day covers campaign planning, data-driven optimisation and the processes that ensure our clients reach more prospects, meetings and new customers.',
        },
      ],
    },
    situations: {
      tag: 'Which one is you?',
      title_a: 'Tell us',
      title_b: 'about it!',
      subtitle: 'If even one of the situations below sounds familiar, chances are we can work together.',
      items: [
        'My product/service is good, but I want more customers.',
        'I want to expand to another country.',
        'I need a professional marketer.',
        'I have no visibility over my paid colleague\'s work: how many companies did we call?',
        'I need a new team member.',
        'I want to reach decision-makers, not generic contacts.',
        'I don\'t have time to search and call every day.',
        'I want solutions, not excuses.',
        'I don\'t spend enough time on my existing customers.',
      ],
    },
    testimonials: {
      tag: 'References',
      title_a: 'Our partners\' successes',
      title_b: 'are our most important references.',
      subtitle: '50+ partners · 4 markets · 5 languages',
      items: [
        {
          company: 'WHC SLOVAKIA',
          role: 'CEO',
          quote:
            'We especially value the team\'s attitude, precision and the fact that they think in terms of real business results. Leadeverest is a partner a growth-oriented company can confidently entrust with part or all of its sales operations.',
        },
        {
          company: 'iNTRETECH',
          role: 'CEO',
          quote:
            'Working with Antal and Antónia, we found a partner that creates real value in our sales processes. The quality of the outreach, the transparency of reporting, and the team\'s expertise confirmed our belief that data-driven sales is essential today.',
        },
        {
          company: 'MOTIM ZRT.',
          role: 'CEO',
          quote:
            'Working with the Leadeverest team, it quickly became clear that we hadn\'t just chosen a service provider — we\'d found a true strategic partner. Their system is transparent, their communication is professional, and every activity is measurable. Leadeverest delivers concrete, accountable results — that\'s why we work with them.',
        },
      ],
    },
    banner_data: {
      eyebrow: 'Data-driven sales',
      title_a: 'We don\'t work from guesses —',
      title_b: 'we build pipeline from numbers.',
      desc:
        'Our own country-structured company database (HU / SK / CZ / AT) is fresh across every filter. From market selection to segmented outreach — one system, one team.',
      label: '79,000+ structured companies',
    },
    banner_measurable: {
      eyebrow: 'Measurable results',
      title_a: 'Weekly status, KPIs, reports —',
      title_b: 'you always know where you stand.',
      desc:
        'Every activity is trackable from week one: emails sent, calls made, booked meetings, conversions. No black box, just clear, data-based decisions.',
      label: 'KPI-driven operation',
    },
    banner_human: {
      eyebrow: 'Human relationships',
      title_a: 'Human calls,',
      title_b: 'real meetings.',
      desc:
        'Trust, honest communication and consistent follow-up are stronger than any trick. We represent your company in HU / SK / CZ / EN / DE — at the decision-maker level.',
      label: '5 languages · 4 markets',
    },
    expansion: {
      tag: 'International expansion',
      title_a: 'New markets —',
      title_b: 'with less risk.',
      desc:
        'Market research, entry strategy, targeted company list, multilingual outreach and local representation — with one team, one contact point. Company setup, bank account, admin optional.',
      markets_label: 'Available markets',
      markets_subtitle: 'countries\nin one process',
      structured_companies: 'structured companies',
      capitals: { HU: 'Budapest', SK: 'Bratislava', CZ: 'Prague', AT: 'Vienna' },
      steps: [
        { title: 'Market research', desc: 'Industry, region, competitive landscape' },
        { title: 'Entry strategy', desc: 'To whom, with what, how' },
        { title: 'Company setup', desc: 'Optional local entity' },
        { title: 'Scaling', desc: 'To the segments that work' },
      ],
      cta_label: 'Ready for the next market?',
      cta_title_a: 'Let us show you in 15 minutes how to start outreach',
      cta_title_b: 'as early as this week.',
    },
    goal: {
      tag: 'Our goal',
      title_a: 'Deliver results —',
      title_b: 'from better account management',
      title_c: 'to new markets.',
      desc:
        'Delivering results — from better account management to increasing sales and opening new markets. With us you gain a reliable partner who supports your business growth step by step.',
      brochure: 'Company brochure',
      mission: 'MISSION',
      mission_title: 'Measurable growth',
    },
    contact: {
      tag: 'Contact',
      title_a: 'Have a question?',
      title_b: 'We reply within 24 hours.',
      offices_label: 'Our offices',
      form: {
        name: 'Name',
        name_ph: 'Full name',
        email: 'Email',
        email_ph: 'name@company.com',
        phone: 'Phone number',
        phone_ph: '+36 70 000 0000',
        company: 'Company',
        company_hint: 'Optional — leave empty as a private person',
        company_ph: 'Company name (if any)',
        message: 'Message',
        message_ph: 'How can we help?',
        send: 'Send message',
        sending: 'Sending…',
        sent: 'Sent',
        privacy:
          'By sending this message you consent to Leadeverest processing your data for the purpose of replying.',
        toast_ok_title: 'Message sent',
        toast_ok_desc: 'We\'ll reply within 24 hours. Thank you!',
        toast_err_title: 'Sending failed',
        toast_err_desc: 'Please try again or write directly: antal@leadeverest.eu',
      },
    },
    footer: {
      description: 'International Sales Agency. Data-driven customer acquisition across HU / SK / CZ / AT markets.',
      nav_label: 'Navigation',
      contact_label: 'Contact',
      offices_label: 'Our offices',
      rights: '— International Sales Agency. All rights reserved.',
    },
    services_page: {
      hero_tag: 'Our services',
      hero_title_a: 'Digital and human sales',
      hero_title_b: 'in sync,',
      hero_title_c: 'optimised for results.',
      hero_desc: 'Six modules, one unified process — from market research to personal representation.',
      anchors: {
        cegadatbazis: 'Company database',
        email: 'Email marketing',
        phone: 'Phone outreach',
        staff: 'Staff placement',
        marketing: 'Marketing',
        expansion: 'Expansion',
      },
      cegdb: {
        tag: 'Data-driven sales',
        title: 'Company database',
        p1: 'It also contains brief company info and website details.',
        p2: 'If you\'ve been searching Google for potential targets, this significantly speeds up research and outreach.',
        p3: 'Our database with named contacts is continuously updated.',
        filters_label: 'The following filters are available:',
        filters: ['Industry', 'Company size (employee count)', 'Number of sites', 'Region'],
        countries: [
          { flag: '🇭🇺', label: 'co.', value: '16,000', country: 'Hungary' },
          { flag: '🇸🇰', label: 'co.', value: '13,000', country: 'Slovakia' },
          { flag: '🇦🇹', label: 'co.', value: '47,000', country: 'Austria' },
          { flag: '🇨🇿', label: 'co.', value: '3,000', country: 'Czech Republic' },
        ],
      },
      email: {
        tag: 'Process',
        title: 'Email marketing',
        desc: 'Plan, schedule and measure campaigns — sent from your company email address.',
        video_label: 'Email marketing',
        steps: [
          { title: 'Selecting the target group from the database', desc: 'Filter by industry, region, company size.' },
          {
            title: 'Bulk email sequences',
            desc: 'Newsletter, introduction, offer messages, with scheduled follow-up and unsubscribe option.',
          },
          {
            title: 'Built-in scheduling (CTA)',
            desc:
              'Recipients book a 15-minute meeting with one click; the system logs the event and adds it to the calendar automatically.',
          },
          {
            title: 'Real-time tracking and reporting',
            desc: 'Delivery, opens, clicks, replies, bookings — measurable per campaign and per recipient.',
          },
          {
            title: 'From your company email address',
            desc:
              'We send the sequences from your company\'s email address, so you can directly track sends, replies and how meetings progress.',
          },
        ],
      },
      phone: {
        tag: 'Service',
        title: 'Phone outreach',
        desc: 'Cold and warmed calls in five languages — for decision-maker meetings.',
        video_label: 'Phone outreach',
        items: [
          { title: 'Cold calls', desc: 'We call companies from the database with a prepared script.' },
          { title: 'Warmed calls', desc: 'We also call those who showed activity in the email campaign.' },
          { title: 'Appointment setting', desc: 'Our goal is to reach the decision-maker and book a meeting for your sales team.' },
          { title: 'Telemarketing', desc: 'Onboarding and phone-based sales + reporting.' },
          {
            title: 'Multilingual outreach',
            desc: 'We handle calls and follow-ups in Hungarian, Slovak, Czech, English and German.',
          },
          {
            title: 'Handover and documentation',
            desc: 'Who was reached, what was said, what the need is, next step, agreed time, or rejection.',
          },
        ],
      },
      staff: {
        tag: 'Service',
        title: 'Staff placement',
        desc: 'Dedicated sales resource — using our workflow, with full equipment provisioning.',
        video_label: 'Staff placement',
        items: [
          {
            title: 'Sales rep, phone sales, administrator or coordinator staffing',
            desc:
              'From CVs you can choose an ad-hoc or long-term partner who is the "face" of your company and communicates on your behalf in HU / SK / CZ / EN / DE.',
          },
          { title: 'System', desc: 'The team member uses our workflow (statuses, follow-up, meeting briefs, reports).' },
          {
            title: 'Full equipment (if needed)',
            desc: 'Company car, phone and laptop provided so work can start immediately at a professional level.',
          },
          { title: 'Onboarding and training', desc: 'Ramp-up on your product and target market.' },
          {
            title: 'Professional supervision',
            desc: 'Management and quality control, weekly status/report + pipeline so we always know where we stand.',
          },
        ],
      },
      marketing: {
        tag: 'Service',
        title: 'Marketing',
        desc: 'Branding, creative production, PPC campaigns and sales materials from one team.',
        video_label: 'Marketing',
        items: [
          { title: 'Branding', desc: 'Visual identity and logo design.' },
          { title: 'Creative production', desc: 'Professional photos, videos, graphic materials, animations — in multiple languages.' },
          { title: 'Sales materials', desc: 'Presentations, offer decks, one-pagers, business cards, promo materials.' },
          { title: 'Online ads (PPC)', desc: 'Campaign planning, setup, continuous optimisation (FB/IG/Google).' },
          { title: 'Social media content and campaigns', desc: 'Posts, ads.' },
          { title: 'Measurement and reporting', desc: 'KPI tracking, lessons learned, fine-tuning and scaling.' },
        ],
      },
      expansion: {
        tag: 'Process',
        title_a: 'Expanding?',
        title_b: 'We help!',
        desc: 'Market research, entry strategy and full local representation across HU/SK/CZ/AT.',
        video_label: 'Expansion',
        steps: [
          { title: 'Market research and targeting', desc: 'Per-country focus (industry, company size, region, competition).' },
          { title: 'Entry strategy and schedule', desc: 'To whom, with what offer, through which channels, in which steps.' },
          {
            title: 'Targeted company list and decision-maker contacts',
            desc: 'In the given country, using our own database (HU / SK / CZ / AT).',
          },
          { title: 'Market-opening outreach campaigns', desc: 'Segmented intro emails + multi-step follow-up.' },
          {
            title: 'Multilingual phone outreach and appointment setting',
            desc: 'In HU / SK / CZ / EN / DE, with qualified meetings.',
          },
          { title: 'Personal representation', desc: 'Ad-hoc projects and long-term projects alike.' },
          {
            title: 'Reporting and optimisation',
            desc: 'Measuring results, fine-tuning, scaling on the best-performing segments.',
          },
          {
            title: 'Optional: Company setup, translation, bank account, other admin',
            desc: 'Practical help for launch and operation.',
          },
        ],
      },
      final_cta: {
        tag: 'Ready for the next step?',
        title_a: 'A 15-minute call',
        title_b: 'about your next market.',
        desc: 'Let us show you how we build measurable pipeline with our own database across HU / SK / CZ / AT.',
      },
    },
    lang_switch: 'Language',
  },

  sk: {
    nav: {
      home: 'Domov',
      services: 'Služby',
      about: 'O nás',
      references: 'Referencie',
      contact: 'Kontakt',
      consultation: 'Bezplatná konzultácia',
      consultation_short: 'Konzultácia',
    },
    common: {
      free_consultation: 'Bezplatná konzultácia',
      our_services: 'Naše služby',
      learn_more: 'Viac',
      contact: 'Kontakt',
      live: 'ŽIVÉ',
      verified: 'Overené',
    },
    hero: {
      tag: 'International Sales Agency',
      title_a: 'Každá minúta, počas ktorej',
      title_b: 'si nevyberú nás,',
      title_c: 'ide vašim konkurentom.',
      description:
        'Predvídateľný, merateľný obchodný pipeline od výberu cieľového trhu až po podpis zmluvy — postavený na vlastnej firemnej databáze, cielených e-mailových kampaniach a viacjazyčnom telefonickom oslovovaní.',
      trust_1: 'Vlastná databáza firiem',
      trust_2: 'Reporty v reálnom čase',
      trust_3: '5 jazykov',
      markets_title: 'Aktívne trhy',
      markets_stat: '79 000+',
      markets_stat_label: 'štruktúrovaných firiem v našej databáze',
    },
    markets: {
      HU: 'Maďarsko',
      SK: 'Slovensko',
      CZ: 'Česko',
      AT: 'Rakúsko',
    },
    services_grid: {
      tag: 'Čo ponúkame',
      title_a: 'Deväť oblastí, jeden jednotný',
      title_b: 'obchodný mechanizmus.',
      subtitle: 'Od firemnej databázy po podpis zmluvy — s jedným tímom počas celej cesty.',
      cards: [
        { title: 'Firemná databáza podľa krajín', tag: 'HU · SK · CZ · AT' },
        { title: 'Dohadovanie stretnutí', tag: null },
        { title: 'Cold calling', tag: null },
        { title: 'Telemarketing', tag: null },
        { title: 'Zabezpečenie pracovníka', tag: null },
        { title: 'Expanzia', tag: 'HU · SK · CZ · AT' },
        { title: 'Branding', tag: null },
        { title: 'Marketing', tag: null },
        { title: 'Sociálne siete', tag: null },
      ],
    },
    about_intro: {
      tag: 'Leadeverest',
      title_a: 'Záleží na',
      title_b: 'výsledkoch.',
      p1:
        'Leadeverest je tím zameraný na výsledky pri získavaní zákazníkov: budujeme predvídateľný, merateľný pipeline od výberu cieľového trhu po podpis zmluvy.',
      p2:
        'Naša silná stránka: vlastná firemná databáza štruktúrovaná podľa krajín (HU / SK / CZ / AT), na ktorej staviame cielené e-mailové kampane a telefonické oslovovanie pre kvalifikované stretnutia, plus poskytujeme dedikovaného SALES pracovníka pre uzatváranie.',
      p3: 'Jazyky: maďarčina, slovenčina, čeština, angličtina, nemčina.',
      p4:
        'Veríme sile medziľudských vzťahov: dôvera, korektná komunikácia a dôsledné sledovanie sú vždy silnejšie ako akýkoľvek „trik".',
    },
    process: {
      tag: 'Naše služby',
      title_a: 'Jeden jasný proces,',
      title_b: 'sedem výnosových modulov.',
      cta_cell_title: 'Otvoriť celú našu ponuku služieb',
      steps: [
        { title: 'Firemná databáza HU / SK / CZ / AT', desc: 'Zoznam firiem s filtrami a kontaktmi.' },
        { title: 'E-mailový marketing', desc: 'Hromadné e-maily + CTA na rezerváciu + report.' },
        { title: 'Telefonické oslovenia', desc: 'Cold cally, telemarketing v HU/SK/CZ/EN/DE.' },
        {
          title: 'Zabezpečenie pracovníka',
          desc:
            'Krátkodobý aj dlhodobý obchodný zdroj podľa potreby v HU/SK/CZ/EN/DE pomocou nášho systému + existujúca starostlivosť o klientov.',
        },
        {
          title: 'Marketing + PPC',
          desc: 'Branding, videá, kreatíva, identita, promo materiály, vizitka, plánovanie a beh kampaní na sociálnych sieťach.',
        },
        {
          title: 'Podpora expanzie (HU/SK/CZ/AT)',
          desc: 'Prieskum trhu, založenie firmy, bankový účet, ostatná administratíva.',
        },
        { title: 'Mesačný report', desc: 'Statusy, KPI, ďalšie kroky, pravidelný súhrn.' },
      ],
    },
    about_stats: {
      tag: 'O nás',
      title_a: 'Pracujeme s dátami,',
      title_b: 'meriame výsledkami,',
      title_c: 'veríme v ľudské vzťahy.',
      story_label: 'Náš príbeh',
      story_1:
        'V roku 2023 sme v Bratislave založili medzinárodnú personálnu agentúru GLOBEFOX — odtiaľto začal medzinárodný sales fókus, ktorý je dnes základom Leadeverest.',
      story_2:
        'Dnes už nábor prebieha aj v Maďarsku, na Slovensku a v Česku a spolupracujeme s viac ako 50 partnermi vrátane výrobných gigantov a lídrov trhu.',
      stats: [
        { value: '2023', label: 'Založené v Bratislave' },
        { value: '50+', label: 'Aktívnych partnerov' },
        { value: '4', label: 'Trhy · HU / SK / CZ / AT' },
        { value: '5', label: 'Jazykov · HU / SK / CZ / EN / DE' },
      ],
      why_label: 'Prečo my',
      why_title_a: 'Štyri princípy, jedna niť:',
      why_title_b: 'výsledok.',
      principles: [
        { title: 'Dátovo riadený predaj', desc: 'Merateľný pipeline z vlastnej databázy — nepracujeme z domnienok.' },
        { title: 'Merateľné výsledky', desc: 'Týždňový status, KPI, reporty — vždy viete, kde je proces a čo nasleduje.' },
        { title: 'Ľudské vzťahy', desc: 'Dôvera, korektná komunikácia a dôsledné follow-up sú silnejšie než akýkoľvek trik.' },
        {
          title: 'Viacjazyčné fungovanie',
          desc: 'Zastupujeme klientov v maďarčine, slovenčine, češtine, angličtine a nemčine — bez hraníc.',
        },
      ],
    },
    team: {
      title_a: 'Tváre',
      title_b: 'za procesmi.',
      section_label: 'Tím',
      members: [
        {
          role: 'Konateľka / CEO · Medzinárodná právnička',
          name: 'Antónia Somogyi',
          bio:
            'V roku 2023 sme v Bratislave založili medzinárodnú personálnu agentúru GLOBEFOX. Ja som sa pridala ako medzinárodná právnička a hovorím štyrmi jazykmi. Vďaka tomu smerovala GLOBEFOX medzinárodne od začiatku a dnes robíme nábor v Maďarsku, na Slovensku aj v Česku. Spolupracujeme s viac ako 50 partnermi vrátane výrobných gigantov a lídrov trhu.',
        },
        {
          role: 'COO / Operačný riaditeľ · Zakladateľ',
          name: 'Antal Korcz',
          bio:
            'Zodpovedám za stratégiu a budovanie predajných systémov: mojim cieľom je, aby každý klient dostal riešenie, ktoré prináša skutočný rast a stabilné získavanie zákazníkov. Denne sa venujem plánovaniu kampaní, dátovej optimalizácii a procesom, vďaka ktorým naši klienti získavajú viac záujemcov, stretnutí a nových zákazníkov.',
        },
      ],
    },
    situations: {
      tag: 'Ktoré platí o vás?',
      title_a: 'Povedzte nám',
      title_b: 'to!',
      subtitle: 'Ak vám je aspoň jedna z nižšie uvedených situácií povedomá, pravdepodobne môžeme spolupracovať.',
      items: [
        'Môj produkt/služba je dobrá, ale chcem viac zákazníkov.',
        'Chcem expandovať do inej krajiny.',
        'Potrebujem profesionálneho marketéra.',
        'Nemám prehľad o práci svojho zamestnanca: koľko firiem sme volali?',
        'Potrebujem nového kolegu.',
        'Chcem osloviť rozhodovateľov, nie generické kontakty.',
        'Nemám čas denne hľadať a volať.',
        'Chcem riešenia, nie výhovorky.',
        'Málo sa venujem existujúcim zákazníkom.',
      ],
    },
    testimonials: {
      tag: 'Referencie',
      title_a: 'Úspechy našich partnerov',
      title_b: 'sú naše najdôležitejšie referencie.',
      subtitle: '50+ partnerov · 4 trhy · 5 jazykov',
      items: [
        {
          company: 'WHC SLOVAKIA',
          role: 'CEO',
          quote:
            'Mimoriadne oceňujeme prístup a presnosť tímu a to, že premýšľajú v reálnych obchodných výsledkoch. Leadeverest je partner, ktorému rastúca firma môže smelo zveriť časť alebo celý obchodný proces.',
        },
        {
          company: 'iNTRETECH',
          role: 'CEO',
          quote:
            'Pri spolupráci s Antalom a Antóniou sme našli partnera, ktorý vytvára reálnu hodnotu v našich obchodných procesoch. Kvalita oslovení, transparentnosť reportingu a odbornosť tímu nás utvrdili v tom, že dátovo riadený predaj je dnes nevyhnutnosť.',
        },
        {
          company: 'MOTIM ZRT.',
          role: 'CEO',
          quote:
            'S tímom Leadeverest bolo rýchlo jasné, že sme si nevybrali len obyčajného dodávateľa, ale skutočného strategického partnera. Ich systém je transparentný, komunikácia profesionálna a každá aktivita merateľná. Leadeverest prináša konkrétne, zúčtovateľné výsledky — preto s nimi pracujeme.',
        },
      ],
    },
    banner_data: {
      eyebrow: 'Dátovo riadený predaj',
      title_a: 'Nepracujeme z domnienok —',
      title_b: 'pipeline staviame z čísel.',
      desc:
        'Naša vlastná databáza firiem štruktúrovaná podľa krajín (HU / SK / CZ / AT) je čerstvá z každého uhla filtra. Od výberu trhu po segmentovanú outreach — jeden systém, jeden tím.',
      label: '79 000+ štruktúrovaných firiem',
    },
    banner_measurable: {
      eyebrow: 'Merateľné výsledky',
      title_a: 'Týždňový status, KPI, reporty —',
      title_b: 'vždy viete, kde ste.',
      desc:
        'Každá aktivita je sledovateľná už od prvého týždňa: odoslané e-maily, hovory, rezervované stretnutia, konverzie. Žiadna čierna skrinka — iba jasné, dátové rozhodnutia.',
      label: 'Fungovanie riadené KPI',
    },
    banner_human: {
      eyebrow: 'Ľudské vzťahy',
      title_a: 'Ľudské hovory,',
      title_b: 'skutočné stretnutia.',
      desc:
        'Dôvera, korektná komunikácia a dôsledný follow-up sú silnejšie ako akýkoľvek trik. Zastupujeme vašu firmu v HU / SK / CZ / EN / DE — na úrovni rozhodovateľov.',
      label: '5 jazykov · 4 trhy',
    },
    expansion: {
      tag: 'Medzinárodná expanzia',
      title_a: 'Nové trhy —',
      title_b: 's menším rizikom.',
      desc:
        'Prieskum trhu, vstupná stratégia, cielený zoznam firiem, viacjazyčný outreach a lokálne zastupovanie — s jedným tímom a jedným kontaktom. Založenie firmy, bankový účet, administratíva voliteľne.',
      markets_label: 'Dostupné trhy',
      markets_subtitle: 'krajiny\nv jednom procese',
      structured_companies: 'štruktúrovaných firiem',
      capitals: { HU: 'Budapešť', SK: 'Bratislava', CZ: 'Praha', AT: 'Viedeň' },
      steps: [
        { title: 'Prieskum trhu', desc: 'Odvetvie, región, konkurenčné prostredie' },
        { title: 'Vstupná stratégia', desc: 'Komu, s čím, ako' },
        { title: 'Založenie firmy', desc: 'Voliteľný lokálny subjekt' },
        { title: 'Škálovanie', desc: 'Na fungujúce segmenty' },
      ],
      cta_label: 'Pripravený na ďalší trh?',
      cta_title_a: 'Ukážeme vám za 15 minút, ako spustiť outreach',
      cta_title_b: 'ešte tento týždeň.',
    },
    goal: {
      tag: 'Náš cieľ',
      title_a: 'Priniesť výsledky —',
      title_b: 'od lepšej starostlivosti o klientov',
      title_c: 'po nové trhy.',
      desc:
        'Prinášame výsledky — od lepšej starostlivosti o klientov cez zvyšovanie predaja až po otváranie nových trhov. S nami získate spoľahlivého partnera, ktorý krok za krokom podporuje rast vášho podnikania.',
      brochure: 'Firemná prezentácia',
      mission: 'MISSION',
      mission_title: 'Merateľný rast',
    },
    contact: {
      tag: 'Kontakt',
      title_a: 'Máte otázku?',
      title_b: 'Odpovieme do 24 hodín.',
      offices_label: 'Naše kancelárie',
      form: {
        name: 'Meno',
        name_ph: 'Celé meno',
        email: 'E-mail',
        email_ph: 'meno@firma.sk',
        phone: 'Telefón',
        phone_ph: '+421 900 000 000',
        company: 'Firma',
        company_hint: 'Nepovinné — ako fyzická osoba nechajte prázdne',
        company_ph: 'Názov firmy (ak existuje)',
        message: 'Správa',
        message_ph: 'Ako môžeme pomôcť?',
        send: 'Odoslať správu',
        sending: 'Odosielam…',
        sent: 'Odoslané',
        privacy:
          'Odoslaním správy súhlasíte so spracovaním vašich údajov spoločnosťou Leadeverest za účelom odpovede.',
        toast_ok_title: 'Správa odoslaná',
        toast_ok_desc: 'Odpovieme do 24 hodín. Ďakujeme!',
        toast_err_title: 'Odoslanie zlyhalo',
        toast_err_desc: 'Skúste to znova alebo píšte priamo: antal@leadeverest.eu',
      },
    },
    footer: {
      description: 'International Sales Agency. Dátovo riadené získavanie zákazníkov na trhoch HU / SK / CZ / AT.',
      nav_label: 'Navigácia',
      contact_label: 'Kontakt',
      offices_label: 'Naše kancelárie',
      rights: '— International Sales Agency. Všetky práva vyhradené.',
    },
    services_page: {
      hero_tag: 'Naše služby',
      hero_title_a: 'Digitálny a ľudský predaj',
      hero_title_b: 'v harmónii,',
      hero_title_c: 'optimalizované na výsledky.',
      hero_desc: 'Šesť modulov, jeden jednotný proces — od prieskumu trhu po osobné zastupovanie.',
      anchors: {
        cegadatbazis: 'Firemná databáza',
        email: 'E-mail marketing',
        phone: 'Telefonické oslovenia',
        staff: 'Pracovník',
        marketing: 'Marketing',
        expansion: 'Expanzia',
      },
      cegdb: {
        tag: 'Dátovo riadený predaj',
        title: 'Firemná databáza',
        p1: 'Obsahuje aj krátke informácie o firmách a kontakty na webové stránky.',
        p2: 'Ak ste doteraz hľadali potenciálnych partnerov cez Google, toto výrazne zrýchli prieskum aj oslovenie.',
        p3: 'Našu databázu s menovitými kontaktmi priebežne aktualizujeme.',
        filters_label: 'K dispozícii sú nasledujúce filtre:',
        filters: ['Odvetvie', 'Veľkosť firmy (employee count)', 'Počet prevádzok', 'Región'],
        countries: [
          { flag: '🇭🇺', label: 'firm', value: '16 000', country: 'Maďarsko' },
          { flag: '🇸🇰', label: 'firm', value: '13 000', country: 'Slovensko' },
          { flag: '🇦🇹', label: 'firm', value: '47 000', country: 'Rakúsko' },
          { flag: '🇨🇿', label: 'firm', value: '3 000', country: 'Česko' },
        ],
      },
      email: {
        tag: 'Proces',
        title: 'E-mail marketing',
        desc: 'Plánovanie, časovanie a meranie kampaní — odoslané z vášho firemného e-mailu.',
        video_label: 'E-mail marketing',
        steps: [
          { title: 'Výber cieľovej skupiny z databázy', desc: 'Filter podľa odvetvia, regiónu, veľkosti.' },
          { title: 'Hromadné e-mailové sekvencie', desc: 'Newsletter, predstavenie, ponuky, s časovaným follow-up a odhlásením.' },
          {
            title: 'Vstavané dohadovanie stretnutí (CTA)',
            desc: 'Príjemca si jedným klikom rezervuje 15-min stretnutie, systém udalosť zaznamená a pridá do kalendára.',
          },
          {
            title: 'Sledovanie a reporting v reálnom čase',
            desc: 'Doručenie, otvorenia, kliky, odpovede, rezervácie — merateľné podľa kampaní aj príjemcov.',
          },
          {
            title: 'Z vašej firemnej e-mailovej adresy',
            desc: 'Sekvencie odosielame z vašej firemnej adresy, takže máte priamy prehľad o odoslaniach, odpovediach a stretnutiach.',
          },
        ],
      },
      phone: {
        tag: 'Služba',
        title: 'Telefonické oslovenia',
        desc: 'Cold a warm hovory v piatich jazykoch — pre stretnutia s rozhodovateľmi.',
        video_label: 'Telefonické oslovenia',
        items: [
          { title: 'Cold cally', desc: 'Voláme firmy z databázy podľa pripraveného scenára.' },
          { title: 'Warm cally', desc: 'Voláme aj tých, ktorí prejavili aktivitu v e-mail kampani.' },
          { title: 'Dohadovanie stretnutí', desc: 'Cieľom je dostať sa k rozhodovateľovi a dohodnúť stretnutie pre obchodníka.' },
          { title: 'Telemarketing', desc: 'Zaškolenie a telefonický predaj + report.' },
          {
            title: 'Viacjazyčné oslovenie',
            desc: 'Hovory a follow-up preberáme v maďarčine, slovenčine, češtine, angličtine aj nemčine.',
          },
          {
            title: 'Odovzdanie a dokumentácia',
            desc: 'S kým bolo, čo padlo, aká je potreba, ďalší krok, dohodnutý termín alebo odmietnutie.',
          },
        ],
      },
      staff: {
        tag: 'Služba',
        title: 'Zabezpečenie pracovníka',
        desc: 'Dedikovaný obchodný zdroj — s naším workflow a plnou technikou.',
        video_label: 'Pracovník',
        items: [
          {
            title: 'Obchodník, telefonický predajca, administratíva alebo koordinátor',
            desc:
              'Z CV môžete vybrať príležitostného alebo dlhodobého partnera, ktorý je „tvárou" firmy a komunikuje v mene vašej firmy v HU / SK / CZ / EN / DE.',
          },
          { title: 'Systém', desc: 'Pracovník používa náš workflow (statusy, follow-up, meeting brief, reporty).' },
          {
            title: 'Kompletné vybavenie podľa potreby',
            desc: 'Firemné auto, telefón a laptop, aby práca mohla ihneď profesionálne bežať.',
          },
          { title: 'Onboarding a školenie', desc: 'Zaškolenie na produkt a cieľový trh.' },
          { title: 'Odborný dohľad', desc: 'Vedenie a kontrola kvality, týždňový status/report + pipeline, aby sme mali vždy prehľad.' },
        ],
      },
      marketing: {
        tag: 'Služba',
        title: 'Marketing',
        desc: 'Branding, kreatívna produkcia, PPC kampane a obchodné materiály z jedného tímu.',
        video_label: 'Marketing',
        items: [
          { title: 'Branding', desc: 'Dizajn identity a loga.' },
          { title: 'Kreatívna produkcia', desc: 'Profesionálne fotografie, videá, grafika, animácie — aj vo viacerých jazykoch.' },
          { title: 'Obchodné materiály', desc: 'Prezentácie, ponuky, one-pagery, vizitky, promo materiály.' },
          { title: 'Online reklama (PPC)', desc: 'Plánovanie, nastavenie, priebežná optimalizácia (FB/IG/Google).' },
          { title: 'Obsah a kampane na sociálnych sieťach', desc: 'Príspevky, reklamy.' },
          { title: 'Meranie a reporting', desc: 'Sledovanie KPI, poučenia, dolaďovanie a škálovanie.' },
        ],
      },
      expansion: {
        tag: 'Proces',
        title_a: 'Expandujete?',
        title_b: 'Pomôžeme!',
        desc: 'Prieskum trhu, vstupná stratégia a plné lokálne zastupovanie na trhoch HU/SK/CZ/AT.',
        video_label: 'Expanzia',
        steps: [
          { title: 'Prieskum trhu a cielenie', desc: 'Fókus podľa krajiny (odvetvie, veľkosť, región, konkurencia).' },
          { title: 'Vstupná stratégia a časovanie', desc: 'Komu predávame, s akou ponukou, kanálmi, v akých krokoch.' },
          {
            title: 'Cielený zoznam firiem a kontakty rozhodovateľov',
            desc: 'V danej krajine, z našej vlastnej databázy (HU / SK / CZ / AT).',
          },
          { title: 'Outreach kampane otvárajúce trh', desc: 'Segmentované predstavovacie e-maily + viackrokový follow-up.' },
          {
            title: 'Viacjazyčné hovory a dohadovanie stretnutí',
            desc: 'V HU / SK / CZ / EN / DE, s kvalifikovanými stretnutiami.',
          },
          { title: 'Osobné zastupovanie', desc: 'Príležitostné aj dlhodobé projekty.' },
          {
            title: 'Reporting a optimalizácia',
            desc: 'Meranie výsledkov, dolaďovanie, škálovanie najlepších segmentov.',
          },
          {
            title: 'Voliteľné: Založenie firmy, preklad, bankový účet, ďalšia administratíva',
            desc: 'Praktická pomoc pri štarte a prevádzke.',
          },
        ],
      },
      final_cta: {
        tag: 'Pripravený na ďalší krok?',
        title_a: '15-minútový hovor',
        title_b: 'o vašom ďalšom trhu.',
        desc: 'Ukážeme vám, ako staviame merateľný pipeline z vlastnej databázy na trhoch HU / SK / CZ / AT.',
      },
    },
    lang_switch: 'Jazyk',
  },

  de: {
    nav: {
      home: 'Startseite',
      services: 'Leistungen',
      about: 'Über uns',
      references: 'Referenzen',
      contact: 'Kontakt',
      consultation: 'Kostenlose Beratung',
      consultation_short: 'Beratung',
    },
    common: {
      free_consultation: 'Kostenlose Beratung',
      our_services: 'Unsere Leistungen',
      learn_more: 'Mehr',
      contact: 'Kontakt',
      live: 'LIVE',
      verified: 'Verifiziert',
    },
    hero: {
      tag: 'International Sales Agency',
      title_a: 'Jede Minute, in der',
      title_b: 'wir nicht gewählt werden,',
      title_c: 'gewinnt Ihre Konkurrenz.',
      description:
        'Eine planbare, messbare Sales-Pipeline von der Zielmarktauswahl bis zum Vertragsabschluss — basierend auf unserer eigenen Firmendatenbank, gezielten E-Mail-Kampagnen und mehrsprachiger Telefonakquise.',
      trust_1: 'Eigene Firmendatenbank',
      trust_2: 'Echtzeit-Reporting',
      trust_3: '5 Sprachen',
      markets_title: 'Aktive Märkte',
      markets_stat: '79.000+',
      markets_stat_label: 'strukturierte Unternehmen in unserer Datenbank',
    },
    markets: {
      HU: 'Ungarn',
      SK: 'Slowakei',
      CZ: 'Tschechien',
      AT: 'Österreich',
    },
    services_grid: {
      tag: 'Was wir anbieten',
      title_a: 'Neun Bereiche, eine einheitliche',
      title_b: 'Sales-Maschine.',
      subtitle: 'Von der Firmendatenbank bis zum Vertrag — durchgängig mit einem Team.',
      cards: [
        { title: 'Firmendatenbank pro Land', tag: 'HU · SK · CZ · AT' },
        { title: 'Terminvereinbarung', tag: null },
        { title: 'Kaltakquise', tag: null },
        { title: 'Telemarketing', tag: null },
        { title: 'Mitarbeiterbereitstellung', tag: null },
        { title: 'Expansion', tag: 'HU · SK · CZ · AT' },
        { title: 'Branding', tag: null },
        { title: 'Marketing', tag: null },
        { title: 'Social Media', tag: null },
      ],
    },
    about_intro: {
      tag: 'Leadeverest',
      title_a: 'Es zählt',
      title_b: 'das Ergebnis.',
      p1:
        'Leadeverest ist ein ergebnisorientiertes Team für Kundengewinnung: Wir bauen eine planbare, messbare Pipeline von der Zielmarktauswahl bis zum Abschluss.',
      p2:
        'Unser starker Wert: unsere eigene, länderweise strukturierte Firmendatenbank (HU / SK / CZ / AT), auf der wir gezielte E-Mail-Kampagnen und Telefonakquise für qualifizierte Meetings aufbauen und dedizierte SALES-Mitarbeiter für Abschlüsse stellen.',
      p3: 'Sprachen: Ungarisch, Slowakisch, Tschechisch, Englisch, Deutsch.',
      p4:
        'Wir glauben an die Kraft menschlicher Beziehungen: Vertrauen, ehrliche Kommunikation und konsequentes Follow-up sind immer stärker als jeder „Trick".',
    },
    process: {
      tag: 'Unsere Leistungen',
      title_a: 'Ein klarer Prozess,',
      title_b: 'sieben umsatzstarke Module.',
      cta_cell_title: 'Zum vollständigen Leistungsangebot',
      steps: [
        { title: 'Firmendatenbank HU / SK / CZ / AT', desc: 'Firmenliste mit Filtern und Kontakten.' },
        { title: 'E-Mail-Marketing', desc: 'Massen-E-Mails + Buchungs-CTA + Reporting.' },
        { title: 'Telefonische Ansprache', desc: 'Kaltakquise, Telemarketing in HU/SK/CZ/EN/DE.' },
        {
          title: 'Mitarbeiterbereitstellung',
          desc:
            'Kurz- und langfristige Vertriebsressource nach Bedarf in HU/SK/CZ/EN/DE mit unserem System + bestehende Kundenbetreuung.',
        },
        {
          title: 'Marketing + PPC',
          desc: 'Branding, Videos, Kreatives, Corporate Design, Promo-Material, Visitenkarten, Social-Media-Planung und -Umsetzung.',
        },
        {
          title: 'Expansions-Support (HU/SK/CZ/AT)',
          desc: 'Marktforschung, Firmengründung, Bankkonto, weitere Verwaltung.',
        },
        { title: 'Monatliches Reporting', desc: 'Status, KPIs, nächste Schritte, regelmäßige Zusammenfassung.' },
      ],
    },
    about_stats: {
      tag: 'Über uns',
      title_a: 'Wir arbeiten mit Daten,',
      title_b: 'wir messen am Ergebnis,',
      title_c: 'wir glauben an Beziehungen.',
      story_label: 'Unsere Geschichte',
      story_1:
        '2023 gründeten wir in Bratislava die GLOBEFOX Internationale Personalvermittlung — von hier startete der internationale Sales-Fokus, der heute die Basis von Leadeverest bildet.',
      story_2:
        'Heute rekrutieren wir auch in Ungarn, der Slowakei und Tschechien und arbeiten mit über 50 Partnern zusammen, darunter Industriegrößen und Marktführer.',
      stats: [
        { value: '2023', label: 'Gegründet in Bratislava' },
        { value: '50+', label: 'Aktive Partner' },
        { value: '4', label: 'Märkte · HU / SK / CZ / AT' },
        { value: '5', label: 'Sprachen · HU / SK / CZ / EN / DE' },
      ],
      why_label: 'Warum wir',
      why_title_a: 'Vier Prinzipien, ein Leitfaden:',
      why_title_b: 'Ergebnisse.',
      principles: [
        { title: 'Datengetriebener Vertrieb', desc: 'Messbare Pipeline aus unserer eigenen Datenbank — kein Bauchgefühl.' },
        { title: 'Messbare Ergebnisse', desc: 'Wöchentlicher Status, KPIs, Reports — Sie wissen immer, wo Sie stehen.' },
        { title: 'Menschliche Beziehungen', desc: 'Vertrauen, ehrliche Kommunikation und konsequentes Follow-up schlagen jeden Trick.' },
        { title: 'Mehrsprachigkeit', desc: 'Wir vertreten Kunden auf Ungarisch, Slowakisch, Tschechisch, Englisch und Deutsch — grenzüberschreitend.' },
      ],
    },
    team: {
      title_a: 'Die Gesichter',
      title_b: 'hinter den Prozessen.',
      section_label: 'Das Team',
      members: [
        {
          role: 'Geschäftsführerin / CEO · International Lawyer',
          name: 'Antónia Somogyi',
          bio:
            '2023 gründeten wir in Bratislava die GLOBEFOX Internationale Personalvermittlung. Ich kam als internationale Juristin dazu und spreche vier Sprachen. Dadurch war GLOBEFOX von Anfang an international ausgerichtet und rekrutiert heute auch in Ungarn, der Slowakei und Tschechien. Aktuell arbeiten wir mit über 50 Partnern, darunter Industriegrößen und Marktführer.',
        },
        {
          role: 'COO / Operativer Leiter · Gründer',
          name: 'Antal Korcz',
          bio:
            'Ich verantworte Strategie und den Aufbau von Vertriebssystemen: Mein Ziel ist, dass jeder Kunde eine Sales-Lösung erhält, die echtes Wachstum und stabile Kundengewinnung bringt. Täglich beschäftige ich mich mit Kampagnenplanung, datenbasierter Optimierung und den Prozessen, die dafür sorgen, dass unsere Kunden mehr Interessenten, Termine und neue Kunden erreichen.',
        },
      ],
    },
    situations: {
      tag: 'Was trifft auf Sie zu?',
      title_a: 'Sagen Sie',
      title_b: 'es uns!',
      subtitle: 'Wenn nur eine der folgenden Situationen bekannt vorkommt, können wir wahrscheinlich zusammenarbeiten.',
      items: [
        'Mein Produkt/meine Leistung ist gut, aber ich möchte mehr Kunden.',
        'Ich möchte in ein anderes Land expandieren.',
        'Ich brauche einen professionellen Marketer.',
        'Ich habe keinen Überblick über die Arbeit meines Mitarbeiters: Wie viele Firmen haben wir angerufen?',
        'Ich brauche einen neuen Mitarbeiter.',
        'Ich möchte Entscheider erreichen, keine generischen Kontakte.',
        'Ich habe keine Zeit, täglich zu suchen und anzurufen.',
        'Ich will Lösungen, keine Ausreden.',
        'Ich kümmere mich zu wenig um bestehende Kunden.',
      ],
    },
    testimonials: {
      tag: 'Referenzen',
      title_a: 'Die Erfolge unserer Partner',
      title_b: 'sind unsere wichtigste Referenz.',
      subtitle: '50+ Partner · 4 Märkte · 5 Sprachen',
      items: [
        {
          company: 'WHC SLOVAKIA',
          role: 'CEO',
          quote:
            'Wir schätzen die Einstellung, Genauigkeit und die Tatsache, dass das Team in echten Geschäftsergebnissen denkt. Leadeverest ist ein Partner, dem ein wachstumsorientiertes Unternehmen Teile oder den gesamten Vertriebsprozess ruhig anvertrauen kann.',
        },
        {
          company: 'iNTRETECH',
          role: 'CEO',
          quote:
            'In der Zusammenarbeit mit Antal und Antónia haben wir einen Partner gefunden, der echten Mehrwert in unseren Vertriebsprozessen schafft. Die Qualität der Ansprache, die Transparenz des Reportings und die Fachkompetenz des Teams haben uns darin bestärkt, dass datengetriebener Vertrieb heute unverzichtbar ist.',
        },
        {
          company: 'MOTIM ZRT.',
          role: 'CEO',
          quote:
            'Mit dem Team von Leadeverest war schnell klar, dass wir keinen einfachen Dienstleister gewählt haben, sondern einen echten strategischen Partner. Ihr System ist transparent, die Kommunikation professionell und jede Aktivität messbar. Leadeverest liefert konkrete, überprüfbare Ergebnisse — deshalb arbeiten wir mit ihnen.',
        },
      ],
    },
    banner_data: {
      eyebrow: 'Datengetriebener Vertrieb',
      title_a: 'Wir arbeiten nicht aus Vermutungen —',
      title_b: 'wir bauen Pipeline aus Zahlen.',
      desc:
        'Unsere eigene, länderweise strukturierte Firmendatenbank (HU / SK / CZ / AT) ist in jedem Filter aktuell. Von der Marktauswahl bis zur segmentierten Outreach — ein System, ein Team.',
      label: '79.000+ strukturierte Unternehmen',
    },
    banner_measurable: {
      eyebrow: 'Messbare Ergebnisse',
      title_a: 'Wöchentlicher Status, KPIs, Reports —',
      title_b: 'Sie wissen immer, wo Sie stehen.',
      desc:
        'Jede Aktivität ist ab der ersten Woche nachvollziehbar: gesendete E-Mails, Anrufe, gebuchte Termine, Konversionen. Keine Black Box — klare, datenbasierte Entscheidungen.',
      label: 'KPI-getriebener Betrieb',
    },
    banner_human: {
      eyebrow: 'Menschliche Beziehungen',
      title_a: 'Menschliche Anrufe,',
      title_b: 'echte Meetings.',
      desc:
        'Vertrauen, ehrliche Kommunikation und konsequentes Follow-up sind stärker als jeder Trick. Wir vertreten Ihr Unternehmen in HU / SK / CZ / EN / DE — auf Entscheider-Ebene.',
      label: '5 Sprachen · 4 Märkte',
    },
    expansion: {
      tag: 'Internationale Expansion',
      title_a: 'Neue Märkte —',
      title_b: 'mit weniger Risiko.',
      desc:
        'Marktforschung, Eintrittsstrategie, gezielte Firmenliste, mehrsprachige Ansprache und lokale Vertretung — mit einem Team, einem Kontakt. Firmengründung, Bankkonto, Verwaltung optional.',
      markets_label: 'Verfügbare Märkte',
      markets_subtitle: 'Länder\nin einem Prozess',
      structured_companies: 'strukturierte Unternehmen',
      capitals: { HU: 'Budapest', SK: 'Bratislava', CZ: 'Prag', AT: 'Wien' },
      steps: [
        { title: 'Marktforschung', desc: 'Branche, Region, Wettbewerbsumfeld' },
        { title: 'Eintrittsstrategie', desc: 'An wen, womit, wie' },
        { title: 'Firmengründung', desc: 'Optional lokale Entität' },
        { title: 'Skalierung', desc: 'Auf funktionierende Segmente' },
      ],
      cta_label: 'Bereit für den nächsten Markt?',
      cta_title_a: 'In 15 Minuten zeigen wir, wie Sie die Outreach starten',
      cta_title_b: 'noch diese Woche.',
    },
    goal: {
      tag: 'Unser Ziel',
      title_a: 'Ergebnisse liefern —',
      title_b: 'von besserer Kundenbetreuung',
      title_c: 'bis zu neuen Märkten.',
      desc:
        'Ergebnisse liefern — von besserer Kundenbetreuung über gesteigerten Vertrieb bis zur Eröffnung neuer Märkte. Bei uns bekommen Sie einen zuverlässigen Partner, der Ihr Wachstum Schritt für Schritt begleitet.',
      brochure: 'Unternehmensbroschüre',
      mission: 'MISSION',
      mission_title: 'Messbares Wachstum',
    },
    contact: {
      tag: 'Kontakt',
      title_a: 'Haben Sie eine Frage?',
      title_b: 'Wir antworten innerhalb von 24 Stunden.',
      offices_label: 'Unsere Büros',
      form: {
        name: 'Name',
        name_ph: 'Vollständiger Name',
        email: 'E-Mail',
        email_ph: 'name@firma.de',
        phone: 'Telefon',
        phone_ph: '+43 700 000 000',
        company: 'Firma',
        company_hint: 'Optional — als Privatperson bitte leer lassen',
        company_ph: 'Firmenname (falls vorhanden)',
        message: 'Nachricht',
        message_ph: 'Wie können wir helfen?',
        send: 'Nachricht senden',
        sending: 'Wird gesendet…',
        sent: 'Gesendet',
        privacy:
          'Mit dem Absenden stimmen Sie zu, dass Leadeverest Ihre Daten zum Zweck der Rückmeldung verarbeitet.',
        toast_ok_title: 'Nachricht gesendet',
        toast_ok_desc: 'Wir antworten innerhalb von 24 Stunden. Danke!',
        toast_err_title: 'Senden fehlgeschlagen',
        toast_err_desc: 'Bitte erneut versuchen oder direkt schreiben: antal@leadeverest.eu',
      },
    },
    footer: {
      description: 'International Sales Agency. Datengetriebene Kundengewinnung auf den Märkten HU / SK / CZ / AT.',
      nav_label: 'Navigation',
      contact_label: 'Kontakt',
      offices_label: 'Unsere Büros',
      rights: '— International Sales Agency. Alle Rechte vorbehalten.',
    },
    services_page: {
      hero_tag: 'Unsere Leistungen',
      hero_title_a: 'Digitaler und menschlicher Vertrieb',
      hero_title_b: 'im Einklang,',
      hero_title_c: 'ergebnisoptimiert.',
      hero_desc: 'Sechs Module, ein einheitlicher Prozess — von Marktforschung bis zur persönlichen Vertretung.',
      anchors: {
        cegadatbazis: 'Firmendatenbank',
        email: 'E-Mail-Marketing',
        phone: 'Telefonakquise',
        staff: 'Mitarbeiter',
        marketing: 'Marketing',
        expansion: 'Expansion',
      },
      cegdb: {
        tag: 'Datengetriebener Vertrieb',
        title: 'Firmendatenbank',
        p1: 'Enthält auch Kurzinfos zu Unternehmen und Website-Kontakte.',
        p2: 'Wenn Sie bislang potenzielle Partner via Google gesucht haben, beschleunigt das Recherche und Ansprache deutlich.',
        p3: 'Unsere Datenbank mit namentlichen Kontakten wird laufend aktualisiert.',
        filters_label: 'Folgende Filter stehen zur Verfügung:',
        filters: ['Branche', 'Firmengröße (employee count)', 'Anzahl Standorte', 'Region'],
        countries: [
          { flag: '🇭🇺', label: 'Firmen', value: '16.000', country: 'Ungarn' },
          { flag: '🇸🇰', label: 'Firmen', value: '13.000', country: 'Slowakei' },
          { flag: '🇦🇹', label: 'Firmen', value: '47.000', country: 'Österreich' },
          { flag: '🇨🇿', label: 'Firmen', value: '3.000', country: 'Tschechien' },
        ],
      },
      email: {
        tag: 'Prozess',
        title: 'E-Mail-Marketing',
        desc: 'Kampagnen planen, timen und messen — von Ihrer Firmen-E-Mail-Adresse aus versendet.',
        video_label: 'E-Mail-Marketing',
        steps: [
          { title: 'Zielgruppen-Auswahl aus der Firmendatenbank', desc: 'Filter nach Branche, Region, Größe.' },
          {
            title: 'Massen-E-Mail-Sequenzen',
            desc: 'Newsletter, Vorstellung, Angebot mit geplantem Follow-up und Abmeldeoption.',
          },
          {
            title: 'Eingebaute Terminbuchung (CTA)',
            desc: 'Empfänger bucht per Klick ein 15-Min-Meeting; das System trägt den Termin automatisch in den Kalender ein.',
          },
          {
            title: 'Echtzeit-Tracking und Reporting',
            desc: 'Zustellung, Öffnungen, Klicks, Antworten, Buchungen — pro Kampagne und Empfänger messbar.',
          },
          {
            title: 'Von Ihrer Firmen-E-Mail-Adresse',
            desc: 'Wir versenden die Sequenzen von Ihrer Firmenadresse, damit Sie Versand, Antworten und Termine direkt nachvollziehen.',
          },
        ],
      },
      phone: {
        tag: 'Leistung',
        title: 'Telefonakquise',
        desc: 'Kalt- und aufgewärmte Anrufe in fünf Sprachen — für Entscheider-Meetings.',
        video_label: 'Telefonakquise',
        items: [
          { title: 'Kaltakquise', desc: 'Wir rufen Firmen aus der Datenbank mit vorbereitetem Leitfaden an.' },
          { title: 'Aufgewärmte Anrufe', desc: 'Auch jene, die auf die E-Mail-Kampagne reagiert haben, werden angerufen.' },
          { title: 'Terminvereinbarung', desc: 'Ziel ist, den Entscheider zu erreichen und einen Termin für Ihren Vertrieb zu setzen.' },
          { title: 'Telemarketing', desc: 'Einarbeitung und telefonischer Vertrieb + Reporting.' },
          {
            title: 'Mehrsprachige Ansprache',
            desc: 'Anrufe und Follow-up übernehmen wir auf Ungarisch, Slowakisch, Tschechisch, Englisch und Deutsch.',
          },
          {
            title: 'Übergabe und Dokumentation',
            desc: 'Mit wem, was besprochen, welche Bedarfslage, nächster Schritt, vereinbarter Termin oder Absage.',
          },
        ],
      },
      staff: {
        tag: 'Leistung',
        title: 'Mitarbeiterbereitstellung',
        desc: 'Dedizierte Vertriebsressource — mit unserem Workflow und voller Ausstattung.',
        video_label: 'Mitarbeiter',
        items: [
          {
            title: 'Vertrieb, Telefonvertrieb, Sachbearbeitung oder Koordination',
            desc:
              'Aus Lebensläufen wählen Sie einen kurz- oder langfristigen Partner, der als „Gesicht" Ihrer Firma in HU / SK / CZ / EN / DE kommuniziert.',
          },
          { title: 'System', desc: 'Der Mitarbeiter nutzt unseren Workflow (Status, Follow-up, Meeting Brief, Reports).' },
          {
            title: 'Vollständige Ausstattung bei Bedarf',
            desc: 'Firmenwagen, Telefon und Laptop, damit die Arbeit sofort professionell starten kann.',
          },
          { title: 'Onboarding und Einarbeitung', desc: 'Vorbereitung auf Produkt und Zielmarkt.' },
          { title: 'Fachliche Aufsicht', desc: 'Führung und Qualitätskontrolle, wöchentlicher Status/Report + Pipeline.' },
        ],
      },
      marketing: {
        tag: 'Leistung',
        title: 'Marketing',
        desc: 'Branding, Kreativproduktion, PPC-Kampagnen und Sales-Unterlagen aus einer Hand.',
        video_label: 'Marketing',
        items: [
          { title: 'Branding', desc: 'Corporate Design und Logo-Entwicklung.' },
          { title: 'Kreativproduktion', desc: 'Professionelle Fotos, Videos, Grafiken, Animationen — auch mehrsprachig.' },
          { title: 'Sales-Unterlagen', desc: 'Präsentationen, Angebote, One-Pager, Visitenkarten, Promo-Material.' },
          { title: 'Online-Werbung (PPC)', desc: 'Kampagnenplanung, Setup, laufende Optimierung (FB/IG/Google).' },
          { title: 'Social-Media-Content und Kampagnen', desc: 'Posts, Anzeigen.' },
          { title: 'Messung und Reporting', desc: 'KPI-Tracking, Erkenntnisse, Feintuning und Skalierung.' },
        ],
      },
      expansion: {
        tag: 'Prozess',
        title_a: 'Wollen Sie expandieren?',
        title_b: 'Wir helfen!',
        desc: 'Marktforschung, Eintrittsstrategie und volle lokale Vertretung auf den Märkten HU/SK/CZ/AT.',
        video_label: 'Expansion',
        steps: [
          { title: 'Marktforschung und Zieldefinition', desc: 'Länderweise Fokus (Branche, Größe, Region, Wettbewerb).' },
          { title: 'Eintrittsstrategie und Zeitplan', desc: 'An wen, mit welchem Angebot, über welche Kanäle, in welchen Schritten.' },
          {
            title: 'Gezielte Firmenliste und Entscheider-Kontakte',
            desc: 'Im jeweiligen Land, aus unserer eigenen Datenbank (HU / SK / CZ / AT).',
          },
          { title: 'Markterschließende Outreach-Kampagnen', desc: 'Segmentierte Vorstellungs-E-Mails + mehrstufiges Follow-up.' },
          {
            title: 'Mehrsprachige Telefonakquise und Terminvereinbarung',
            desc: 'In HU / SK / CZ / EN / DE, mit qualifizierten Meetings.',
          },
          { title: 'Persönliche Vertretung', desc: 'Sowohl Ad-hoc- als auch langfristige Projekte.' },
          {
            title: 'Reporting und Optimierung',
            desc: 'Ergebnisse messen, feintunen, auf die besten Segmente skalieren.',
          },
          {
            title: 'Optional: Firmengründung, Übersetzung, Bankkonto, weitere Verwaltung',
            desc: 'Praktische Hilfe für Start und Betrieb.',
          },
        ],
      },
      final_cta: {
        tag: 'Bereit für den nächsten Schritt?',
        title_a: 'Ein 15-minütiges Gespräch',
        title_b: 'über Ihren nächsten Markt.',
        desc: 'Wir zeigen, wie wir eine messbare Pipeline aus unserer eigenen Datenbank auf HU / SK / CZ / AT aufbauen.',
      },
    },
    lang_switch: 'Sprache',
  },
};
